import type { TruckConfiguration } from '#app/store/slices/configurationSlice'

export function hasUnsavedChanges(configuration: TruckConfiguration | undefined) {
  if (!configuration) {
    return false
  }

  if (configuration.apiConfiguration.mode === 'read-only') {
    return false
  }

  if (configuration.step.stage === 'PendingStep') {
    return false
  }

  if (configuration.history?.some((x) => x.status === 'pending' || x.status === 'queued')) {
    return true
  }

  if (!configuration.lastChange) {
    return !configuration.apiConfiguration.manCode
  }

  return configuration.lastManCodeUpdate?.when
    ? configuration.lastChange.version !== configuration.lastManCodeUpdate.version
    : !configuration.apiConfiguration.manCode
}
